import { render, staticRenderFns } from "./HowToTake.vue?vue&type=template&id=52fb44e6&scoped=true"
import script from "./HowToTake.vue?vue&type=script&lang=js"
export * from "./HowToTake.vue?vue&type=script&lang=js"
import style0 from "./HowToTake.vue?vue&type=style&index=0&id=52fb44e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fb44e6",
  null
  
)

export default component.exports